import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { ControlContainer, UntypedFormArray } from '@angular/forms';

@Component({
    selector: 'owner-form-array',
    templateUrl: './owner-form-array.component.html',
    styleUrls: ['./owner-form-array.component.scss'],
    standalone: false
})
export class OwnerFormArrayComponent implements OnInit, AfterViewInit {
  @ContentChild('ownerTemplate', { static: true })
  optionTemplateRef: TemplateRef<any>;
  ownerFormArray: UntypedFormArray;

  constructor(
    private controlContainer: ControlContainer,
    private cd: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.ownerFormArray = this.controlContainer.control as UntypedFormArray;
  }
}
